<template>
  <v-container fluid style="padding-right:0px; padding-bottom:0px">
    <campaigns-helpers :data="cleanData" :hotRef="hotRef" />
      <div class="hot">
        <hot-table :data="cleanData" :settings="hotSettings" ref="hotTableComponent" id="ads-table"/>
      </div>
  </v-container>
</template>

<script>
  import { HotTable } from '@handsontable/vue'
  // eslint-disable-next-line no-unused-vars
  import Handsontable from 'handsontable'
  import CampaignsHelpers from './CampaignsHelpers'
  import {
    normalizeAdSetData
  } from '../../../helpers/functions'
  import adSetData from '../../../../static/dummy-data/sample-ads.json'

  export default {
    name: 'Campaigns',
    components: {
      HotTable,
      CampaignsHelpers
    },
    data () {
      return {
        adSetData,
        hotSettings: {
          licenseKey: 'non-commercial-and-evaluation',
          nestedHeaders: [
            [
              {label: '', colspan: 2},
              {label: 'Budget & Schedule', colspan: 4},
              {label: 'Audience', colspan: 2},
              {label: 'Geo', colspan: 2},
              {label: 'Optimization', colspan: 3}
            ],
            ['Campaign', 'Ad set', 'Daily budget', 'Lifetime budget', 'Start time', 'End time', 'Audience', 'Audience splits', 'Geo', 'Geo splits', 'Success metric', 'Conversion pixel', 'Conversion event']
          ],
          columns: [
            {data: 'CampaignName'},
            {data: 'AdSetName'},
            {data: 'AdSetDailyBudget'},
            {data: 'AdSetLifetimeBudget'},
            {data: 'AdSetTimeStart'},
            {data: 'AdSetTimeEnd'},
            {data: 'audience'},
            {data: 'audience_splits'},
            {data: 'geo'},
            {data: 'geo_splits'},
            {data: 'success_metric'},
            {data: 'pixel'},
            {data: 'conversion_event'}
          ],
          rowHeaders: true,
          width: '100%',
          stretchH: 'all',
          height: 560,
          colWidths: 90,
          fixedColumnsLeft: 2,
          cells: function (row, col) {
            var cellProperties = {}

            if (col === 1) {
              cellProperties.colWidths = 200
            // } else if (col === 1) {
            //   cellProperties.colWidths = 150
            // } else if (col === 2) {
            //   cellProperties.colWidths = 200
            }

            return cellProperties
          },
          dropdownMenu: ['filter_by_value', 'filter_action_bar'],
          filters: true,
          headerTooltips: {
            columns: true,
            onlyTrimmed: true
          },
          hiddenColumns: {
            indicators: true
          },
          contextMenu: ['row_above', 'row_below', 'remove_row'],
          outsideClickDeselects: false,
          minSpareRows: 1
        },
        hotRef: {}
        // id: 'my-custom-id',
        // className: 'my-custom-classname',
        // style: 'width: 300px; height: 142px; overflow: hidden; border: 1px solid red;'
      }
    },
    computed: {
      cleanData () {
        return normalizeAdSetData(this.adSetData)
      }
    },
    methods: {
    },
    mounted () {
      this.adSetData = adSetData
      this.hotRef = this.$refs.hotTableComponent.hotInstance
    }
  }
</script>
<style>
    .component-fade-enter-active, .component-fade-leave-active {
        transition: opacity .3s ease;
    }
    .component-fade-enter, .component-fade-leave-to
        /* .component-fade-leave-active below version 2.1.8 */ {
        opacity: 0;
    }
    .switch label {
      color: white!important
    }
</style>
